module.exports = __webpack_public_path__ + "img/d201006-1.f234cd15.jpg";